import { render } from "./PageWrapper.vue?vue&type=template&id=14008cc6"
import script from "./PageWrapper.vue?vue&type=script&lang=js"
export * from "./PageWrapper.vue?vue&type=script&lang=js"
script.render = render

export default script